var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item)?_c('div',{staticClass:"page"},_vm._l((_vm.body),function(slice){return _c('slice'+slice.slice_type,{key:slice.id,tag:"component",attrs:{"item":_vm.item,"slice":slice}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }